import { c as _c } from "react/compiler-runtime";
import { graphql, useQuery } from "@opensea/graphql";
import { useEffect, useState } from "react";
import { NETWORK_ONLY_OPERATION_CONTEXT } from "../../../constants";
import { useAllActionsCompleted } from "../../hooks/useAllActionsCompleted";
import { useEndFlowOnAccountChange } from "../../hooks/useEndFlowOnAccountChange";
import { DropPublishStatus, DropPublishStatusCollectionFragment } from "./components/DropPublishStatus";
import { DropPublishTimeline } from "./components/DropPublishTimeline";
import { DropPublishFlowSkeleton } from "./DropPublishFlowSkeleton";
const DropPublishCollectionQuery = graphql(`
    query DropPublishCollectionQuery($slug: String!) {
      collectionBySlug(slug: $slug) {
        ... on Collection {
          name
          imageUrl
          ...DropPublishStatusCollection
        }
      }
    }
  `, [DropPublishStatusCollectionFragment]);
export const DropPublishFlow = t0 => {
  const $ = _c(15);
  const {
    collectionSlug
  } = t0;
  const [view, setView] = useState("timeline");
  const [allActionsCompleted] = useAllActionsCompleted();
  let t1;
  if ($[0] !== collectionSlug) {
    t1 = {
      query: DropPublishCollectionQuery,
      variables: {
        slug: collectionSlug
      },
      context: NETWORK_ONLY_OPERATION_CONTEXT
    };
    $[0] = collectionSlug;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [t2] = useQuery(t1);
  const {
    data: collectionData,
    fetching: collectionFetching
  } = t2;
  useEndFlowOnAccountChange();
  let t3;
  let t4;
  if ($[2] !== allActionsCompleted || $[3] !== view) {
    t3 = () => {
      if (allActionsCompleted && view === "timeline") {
        setView("done");
      }
    };
    t4 = [allActionsCompleted, view];
    $[2] = allActionsCompleted;
    $[3] = view;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  useEffect(t3, t4);
  if (collectionFetching) {
    let t5;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <DropPublishFlowSkeleton />;
      $[6] = t5;
    } else {
      t5 = $[6];
    }
    return t5;
  }
  const collection = collectionData?.collectionBySlug;
  if (collection?.__typename !== "Collection") {
    let t5;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <DropPublishFlowSkeleton />;
      $[7] = t5;
    } else {
      t5 = $[7];
    }
    return t5;
  }
  const collectionName = collection.name;
  const collectionImageUrl = collection.imageUrl;
  switch (view) {
    case "timeline":
      {
        let t5;
        if ($[8] !== collectionImageUrl || $[9] !== collectionName || $[10] !== collectionSlug) {
          t5 = <DropPublishTimeline collectionImageUrl={collectionImageUrl} collectionName={collectionName} collectionSlug={collectionSlug} />;
          $[8] = collectionImageUrl;
          $[9] = collectionName;
          $[10] = collectionSlug;
          $[11] = t5;
        } else {
          t5 = $[11];
        }
        return t5;
      }
    case "done":
      {
        let t5;
        if ($[12] !== allActionsCompleted || $[13] !== collection) {
          t5 = <DropPublishStatus collection={collection} success={allActionsCompleted} />;
          $[12] = allActionsCompleted;
          $[13] = collection;
          $[14] = t5;
        } else {
          t5 = $[14];
        }
        return t5;
      }
    default:
      {
        return null;
      }
  }
};